import api from '@/services/Api';
import Anforderung from '@/types/Anforderung';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { AnforderungenState, RootState } from '@/store/types';
import { Termindauer } from '@/types/Terminkalender';

export type AnforderungenFilter = { gueltig: string };
export type LoadAnforderungenPayload = { filter: AnforderungenFilter };
export type UpdateAnforderungPayload = { anforderung: Anforderung; filter: AnforderungenFilter };
export type DeleteAnforderungPayload = { anforderung: Anforderung; filter: AnforderungenFilter };

type Context = ActionContext<AnforderungenState, RootState>;

export const anforderungen: Module<AnforderungenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            anforderungen: false,
        },
        anforderungen: [],
        dauer: [],
    },
    actions: {
        loadAnforderungen({ commit }: Context, payload?: LoadAnforderungenPayload): void {
            commit('setLoadersAnforderungen', true);
            commit('setAnforderungen', []);

            api.post('terminkalender/anforderungen/load', payload)
                .then((response: AxiosResponse) => {
                    commit('setAnforderungen', response.data.body);
                    commit('setDauer', response.data.selections?.dauer ?? []);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersAnforderungen', false));
        },
        updateAnforderung({ commit, dispatch }: Context, { anforderung, filter }: UpdateAnforderungPayload): void {
            commit('setLoadersSave', true);

            api.post('terminkalender/anforderungen/speichern', anforderung)
                .then(() => {
                    successSwal('Anforderung', 'gespeichert');
                    dispatch('loadAnforderungen', { filter });
                    dispatch('terminkalender/exportSync', { source: 'anforderungen' }, { root: true });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteAnforderung({ commit, dispatch }: Context, { anforderung, filter }: DeleteAnforderungPayload): void {
            commit('setLoadersDelete', true);

            api.post('terminkalender/anforderungen/loeschen', anforderung)
                .then(() => {
                    successSwal('Anforderung', 'gelöscht');
                    dispatch('loadAnforderungen', { filter });
                    dispatch('terminkalender/exportSync', { source: 'anforderungen' }, { root: true });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setAnforderungen(state: AnforderungenState, payload: Partial<Anforderung>[]): void {
            state.anforderungen = payload.map((data) => new Anforderung(data));
        },
        setDauer(state: AnforderungenState, payload: Partial<Termindauer>[]): void {
            state.dauer = payload.map((data) => new Termindauer(data));
        },
        setDialogsDetail(state: AnforderungenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: AnforderungenState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: AnforderungenState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersAnforderungen(state: AnforderungenState, visible: boolean): void {
            state.loaders.anforderungen = visible;
        },
    },
};
